module.exports = __webpack_public_path__ + "img/user_grey.9ba69b90.svg";